import FlexRow, { FlexRowProps } from './FlexRow';

export interface MenuItemProps extends FlexRowProps {
  color?:				string;
  icon:					string;
  label:				string;
}

const MenuItem = (mprops: MenuItemProps) => {
  const { color, icon, label, ...props } = mprops;
  
  const c =	color === undefined
  			?	'!text-black'
  			:	color;
  
  return (
  <FlexRow className={[
             'text-[16px] gap-[8px] px-[8px] py-[4px] cursor-pointer hover:bg-blue-100',
             c,
           ]}
           {...props}>
    <span className={[
            'material-icons text-[16px]',
            c,
          ].join(" ")}>
      { icon}
    </span>
    <div className="r12">
      { label }
    </div>
  </FlexRow>
  );
};



export default MenuItem;
